// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_container__UGOxM {
  background: var(--table-row-white);
  border: 1px solid var(--table-border);
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-height: 400px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.style_header__w4MV3 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.style_titleRow__9ft5z {
  display: flex;
  align-items: center;
  gap: 8px;
}

.style_viewCalendar__sEy4h {
  margin-left: auto;
  cursor: pointer;
  font-size: 0.875rem;
}

.style_viewCalendar__sEy4h:hover {
  text-decoration: underline;
}

.style_calendar__PAOMe {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.style_monthHeader__n0j-K {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.style_monthNav__E\\+CWY {
  display: flex;
  gap: 4px;
}

.style_dayNames__0wpvb {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
  margin-bottom: 8px;
}

.style_dayName__rBqbq {
  text-align: center;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-secondary);
  padding: 4px;
}

.style_calendarGrid__Y9Jd9 {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.style_calendarDay__ZArS2 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  font-size: 0.875rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.style_calendarDay__ZArS2:hover {
  background-color: var(--table-hover);
}

.style_calendarDay__ZArS2.style_otherMonth__C5eG8 {
  color: var(--text-secondary);
}

.style_calendarDay__ZArS2.style_today__yCfeB {
  background-color: #3b82f6;
  color: white;
  font-weight: 600;
}

.style_calendarDay__ZArS2.style_hasTask__kV6wd {
  background-color: #dbeafe;
  color: #1d4ed8;
  font-weight: 500;
}

.style_taskDot__dfxB\\+ {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 4px;
  height: 4px;
  background-color: #3b82f6;
  border-radius: 50%;
}

.style_calendarDay__ZArS2.style_today__yCfeB .style_taskDot__dfxB\\+ {
  background-color: white;
}

.style_taskList__uRz9y {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 120px;
}

.style_taskWrapper__MemqO {
  position: relative;
}

.style_taskWrapper__MemqO button {
  width: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 12px !important;
  padding: 10px 12px !important;
  border-radius: 8px !important;
  background-color: var(--table-row-white) !important;
  border: 1px solid var(--table-border) !important;
  border-left: 4px solid #3b82f6 !important;
  transition: all 0.2s ease !important;
  text-align: left !important;
  color: var(--text-primary) !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  text-transform: none !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
}

.style_taskWrapper__MemqO button:hover:not(:disabled) {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-1px) !important;
  background-color: var(--table-hover) !important;
}

.style_taskWrapper__MemqO button:disabled {
  cursor: not-allowed !important;
  opacity: 0.5 !important;
  background-color: var(--table-hover) !important;
}

/* Color coding based on task status */
.style_taskWrapper__MemqO button[style*='outdated'] {
  background-color: #fdd2d2 !important;
  border-left-color: #963333 !important;
}

.style_taskWrapper__MemqO button[style*='F8EDED'] {
  background-color: #f8eded !important;
  border-left-color: #b44f4f !important;
}

.style_taskItem__f1ZrC {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px;
  border-radius: 6px;
  background-color: var(--table-row-alt);
  border-left: 3px solid #3b82f6;
  transition: all 0.2s ease;
}

.style_taskItem__f1ZrC:hover:not(.style_taskDisabled__DzaXa) {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transform: translateX(2px);
}

.style_taskDisabled__DzaXa {
  pointer-events: none;
}

.style_taskContent__QkISI {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
}

.style_taskDate__tU2M5 {
  font-size: 0.75rem;
  color: var(--text-secondary);
  font-weight: 500;
}

.style_taskTitle__mjbIs {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-heading);
  line-height: 1.2;
}

.style_taskDetails__lbYn- {
  font-size: 0.75rem;
  color: var(--text-secondary);
  line-height: 1.3;
}

.style_noTasks__rTFa9 {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
  color: var(--text-secondary);
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .style_container__UGOxM {
    padding: 12px;
  }

  .style_calendarDay__ZArS2 {
    height: 28px;
    font-size: 0.8rem;
  }

  .style_taskItem__f1ZrC {
    padding: 6px;
  }

  .style_monthHeader__n0j-K {
    flex-direction: column;
    gap: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UpcomingMaintenanceCalendar/style.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,oBAAoB;EACpB,6BAA6B;EAC7B,6BAA6B;EAC7B,mDAAmD;EACnD,gDAAgD;EAChD,yCAAyC;EACzC,oCAAoC;EACpC,2BAA2B;EAC3B,qCAAqC;EACrC,8BAA8B;EAC9B,2BAA2B;EAC3B,+BAA+B;EAC/B,oDAAoD;AACtD;;AAEA;EACE,mDAAmD;EACnD,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA,sCAAsC;AACtC;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF","sourcesContent":[".container {\n  background: var(--table-row-white);\n  border: 1px solid var(--table-border);\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.titleRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.viewCalendar {\n  margin-left: auto;\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.viewCalendar:hover {\n  text-decoration: underline;\n}\n\n.calendar {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.monthHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.monthNav {\n  display: flex;\n  gap: 4px;\n}\n\n.dayNames {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 4px;\n  margin-bottom: 8px;\n}\n\n.dayName {\n  text-align: center;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  padding: 4px;\n}\n\n.calendarGrid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n\n.calendarDay {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  font-size: 0.875rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.calendarDay:hover {\n  background-color: var(--table-hover);\n}\n\n.calendarDay.otherMonth {\n  color: var(--text-secondary);\n}\n\n.calendarDay.today {\n  background-color: #3b82f6;\n  color: white;\n  font-weight: 600;\n}\n\n.calendarDay.hasTask {\n  background-color: #dbeafe;\n  color: #1d4ed8;\n  font-weight: 500;\n}\n\n.taskDot {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 4px;\n  height: 4px;\n  background-color: #3b82f6;\n  border-radius: 50%;\n}\n\n.calendarDay.today .taskDot {\n  background-color: white;\n}\n\n.taskList {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-height: 120px;\n}\n\n.taskWrapper {\n  position: relative;\n}\n\n.taskWrapper button {\n  width: 100% !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 12px !important;\n  padding: 10px 12px !important;\n  border-radius: 8px !important;\n  background-color: var(--table-row-white) !important;\n  border: 1px solid var(--table-border) !important;\n  border-left: 4px solid #3b82f6 !important;\n  transition: all 0.2s ease !important;\n  text-align: left !important;\n  color: var(--text-primary) !important;\n  font-size: 0.875rem !important;\n  font-weight: 500 !important;\n  text-transform: none !important;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;\n}\n\n.taskWrapper button:hover:not(:disabled) {\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n  transform: translateY(-1px) !important;\n  background-color: var(--table-hover) !important;\n}\n\n.taskWrapper button:disabled {\n  cursor: not-allowed !important;\n  opacity: 0.5 !important;\n  background-color: var(--table-hover) !important;\n}\n\n/* Color coding based on task status */\n.taskWrapper button[style*='outdated'] {\n  background-color: #fdd2d2 !important;\n  border-left-color: #963333 !important;\n}\n\n.taskWrapper button[style*='F8EDED'] {\n  background-color: #f8eded !important;\n  border-left-color: #b44f4f !important;\n}\n\n.taskItem {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 8px;\n  border-radius: 6px;\n  background-color: var(--table-row-alt);\n  border-left: 3px solid #3b82f6;\n  transition: all 0.2s ease;\n}\n\n.taskItem:hover:not(.taskDisabled) {\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transform: translateX(2px);\n}\n\n.taskDisabled {\n  pointer-events: none;\n}\n\n.taskContent {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n}\n\n.taskDate {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n.taskTitle {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-heading);\n  line-height: 1.2;\n}\n\n.taskDetails {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  line-height: 1.3;\n}\n\n.noTasks {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  text-align: center;\n  color: var(--text-secondary);\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .container {\n    padding: 12px;\n  }\n\n  .calendarDay {\n    height: 28px;\n    font-size: 0.8rem;\n  }\n\n  .taskItem {\n    padding: 6px;\n  }\n\n  .monthHeader {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style_container__UGOxM`,
	"header": `style_header__w4MV3`,
	"titleRow": `style_titleRow__9ft5z`,
	"viewCalendar": `style_viewCalendar__sEy4h`,
	"calendar": `style_calendar__PAOMe`,
	"monthHeader": `style_monthHeader__n0j-K`,
	"monthNav": `style_monthNav__E+CWY`,
	"dayNames": `style_dayNames__0wpvb`,
	"dayName": `style_dayName__rBqbq`,
	"calendarGrid": `style_calendarGrid__Y9Jd9`,
	"calendarDay": `style_calendarDay__ZArS2`,
	"otherMonth": `style_otherMonth__C5eG8`,
	"today": `style_today__yCfeB`,
	"hasTask": `style_hasTask__kV6wd`,
	"taskDot": `style_taskDot__dfxB+`,
	"taskList": `style_taskList__uRz9y`,
	"taskWrapper": `style_taskWrapper__MemqO`,
	"taskItem": `style_taskItem__f1ZrC`,
	"taskDisabled": `style_taskDisabled__DzaXa`,
	"taskContent": `style_taskContent__QkISI`,
	"taskDate": `style_taskDate__tU2M5`,
	"taskTitle": `style_taskTitle__mjbIs`,
	"taskDetails": `style_taskDetails__lbYn-`,
	"noTasks": `style_noTasks__rTFa9`
};
export default ___CSS_LOADER_EXPORT___;
